import { Color } from '../../../../color/Color.mjs';
import { FillGradient } from '../fill/FillGradient.mjs';
import { parseSVGFloatAttribute } from './parseSVGFloatAttribute.mjs';

"use strict";
function parseSVGDefinitions(svg, session) {
  const definitions = svg.querySelectorAll("defs");
  for (let i = 0; i < definitions.length; i++) {
    const definition = definitions[i];
    for (let j = 0; j < definition.children.length; j++) {
      const child = definition.children[j];
      switch (child.nodeName.toLowerCase()) {
        case "lineargradient":
          session.defs[child.id] = parseLinearGradient(child);
          break;
        case "radialgradient":
          session.defs[child.id] = parseRadialGradient(child);
          break;
        default:
          break;
      }
    }
  }
}
function parseGradientCoordinate(svg, id, defaultValue) {
  const value = svg.getAttribute(id);
  if (value?.trim().endsWith("%")) {
    const percentage = Number(value.trim().slice(0, -1));
    return Number.isNaN(percentage) ? defaultValue : percentage / 100;
  }
  return parseSVGFloatAttribute(svg, id, defaultValue);
}
function parseGradientTextureSpace(svg) {
  return (svg.getAttribute("gradientUnits") || "objectBoundingBox") === "objectBoundingBox" ? "local" : "global";
}
function parseGradientColorStops(svg) {
  const colorStops = [];
  for (let i = 0; i < svg.children.length; i++) {
    const stop = svg.children[i];
    const offset = parseGradientCoordinate(stop, "offset", 0);
    const color = Color.shared.setValue(stop.getAttribute("stop-color")).toNumber();
    colorStops.push({ offset, color });
  }
  return colorStops;
}
function parseLinearGradient(child) {
  const x0 = parseGradientCoordinate(child, "x1", 0);
  const y0 = parseGradientCoordinate(child, "y1", 0);
  const x1 = parseGradientCoordinate(child, "x2", 1);
  const y1 = parseGradientCoordinate(child, "y2", 0);
  return new FillGradient({
    type: "linear",
    start: { x: x0, y: y0 },
    end: { x: x1, y: y1 },
    textureSpace: parseGradientTextureSpace(child),
    colorStops: parseGradientColorStops(child)
  });
}
function parseRadialGradient(child) {
  const cx = parseGradientCoordinate(child, "cx", 0.5);
  const cy = parseGradientCoordinate(child, "cy", 0.5);
  const r = parseGradientCoordinate(child, "r", 0.5);
  const fx = parseGradientCoordinate(child, "fx", cx);
  const fy = parseGradientCoordinate(child, "fy", cy);
  const fr = parseGradientCoordinate(child, "fr", 0);
  return new FillGradient({
    type: "radial",
    center: { x: fx, y: fy },
    innerRadius: fr,
    outerCenter: { x: cx, y: cy },
    outerRadius: r,
    textureSpace: parseGradientTextureSpace(child),
    colorStops: parseGradientColorStops(child)
  });
}

export { parseSVGDefinitions };
//# sourceMappingURL=parseSVGDefinitions.mjs.map
